import React from 'react';
import PropTypes from 'prop-types';
import { Field } from 'redux-form';
import FormTextField from '../legacyForm/FormTextField';
import ApplicationFormTextField from './applicationForm/ApplicationFormTextField';
import ApplicationFormLocationField from './applicationForm/ApplicationFormLocationField';
import ApplicationFormCostsField from './applicationForm/ApplicationFormCostsField';

const validate = (fieldValue, _, props) => {
  const fieldDefinition = props.budget.applicationTemplate.form[0];

  if (!fieldValue) {
    if (fieldDefinition.isOptional) return undefined;
    else return 'Pole jest wymagane';
  }
  const lengthLimit = fieldDefinition.constraints.maxLength != null
    ? fieldDefinition.constraints.maxLength
    : fieldDefinition.constraints.maxLengthLimit;

  if (fieldValue.length > lengthLimit)
    return `Długość pola nie może być większa niż ${lengthLimit} znaki(ów). Wprowadzono ${fieldValue.length} znaki(ów).`;
  return undefined;
};


const renderFormField = (field, index, applicationForm, budget, parcelsAutocompletion, change, locations, totalCost, form, readonly) => {
  switch (field.type) {
    case 'location': {
      return (<ApplicationFormLocationField
        key={field.id}
        field={field}
        index={index}
        applicationForm={applicationForm}
        budgetId={budget.id}
        parcelsAutocompletion={parcelsAutocompletion}
        change={change}
        locations={locations}
        readonly={readonly}
      />);
    }
    case 'costs': {
      return (<ApplicationFormCostsField
        key={field.id}
        field={field}
        index={index}
        applicationForm={applicationForm}
        change={change}
        totalCost={totalCost}
        readonly={readonly}
      />);
    }
    case 'description':
    case 'text': {
      const submissionIndex = form.filter(d => d.type === 'description' || d.type === 'text').findIndex(d => d.id === field.id);
      return <ApplicationFormTextField key={field.id} field={field} budget={budget} index={index} 
      submissionIndex={submissionIndex} readonly={readonly} />;
    }
    default: return null;
  }
};

let BudgetApplicationFormItems = ({
  change,
  applicationForm,
  budget,
  parcelsAutocompletion,
  locations,
  totalCost,
  readonly }) => {
  const fieldDef = applicationForm.form.find(f => f.type === 'name');
  return (
    <React.Fragment>
      <div className="box">
        <div className="col-sm-12">
          <h3>1. {applicationForm.nameFieldTitle}</h3>
          <p>{fieldDef.description}</p>
          <div>
            <Field
              name="title"
              component={FormTextField}
              fullWidth
              helperText={fieldDef.constraints.maxLength ? `Długość pola nie może być większa niż ${fieldDef.constraints.maxLength} znaki(ów).` : undefined}
              validate={validate}
              inputProps={{ 'aria-label': 'Nazwa projektu' }}
              disabled={readonly}
            />
          </div>
        </div>
      </div>
      {applicationForm.form.map((field, index) => renderFormField(field, index, applicationForm, budget, parcelsAutocompletion, change, locations, totalCost, applicationForm.form, readonly))}
    </React.Fragment>
  );
}

BudgetApplicationFormItems.propTypes = {
  change: PropTypes.func.isRequired,
  applicationForm: PropTypes.object.isRequired,
  budget: PropTypes.object.isRequired,
  parcelsAutocompletion: PropTypes.bool,
  locations: PropTypes.array,
  totalCost: PropTypes.number,
  readonly: PropTypes.bool,
};

export default BudgetApplicationFormItems;



// WEBPACK FOOTER //
// ./src/components/budget/BudgetApplicationFormItems.js